import React, { useEffect, useState } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ReactTable from 'components/ReactTable/ReactTable';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { wsFindBy, wsPost } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';
import { Add } from '@material-ui/icons';
import { Toasty, useToasty } from 'hooks/Toasty';
import { makeStyles } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import Badge from 'components/Badge/Badge';
import { nDecimal } from 'hooks/Pipe';
import SireModal from './SireModal';
import { AllowedGuard } from '../UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import ButtonDelete from 'hooks/ButtonDelete';

const useStyles = makeStyles(() => ({ ...styles }));

const TIPO_LABEL = { '01': 'Factura', '03': 'Boleta', '07': 'N. Crédito', '08': 'N. Débito' };

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Existe SAP', accessor: 'existsBadge', width: 110 },
  { Header: 'Tipo', accessor: 'tipo', width: 110 },
  { Header: 'Serie', accessor: 'serie', width: 90 },
  { Header: 'Número', accessor: 'number', width: 110 },
  { Header: 'RUC / DNI', accessor: 'ruc', width: 130 },
  { Header: 'Código', accessor: 'card_code', width: 110 },
  { Header: 'Razón Social', accessor: 'partner_name' },
  { Header: 'Emisión', accessor: 'doc_date', width: 120 },
  { Header: 'Total', accessor: 'total', width: 130 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

// Listado de comprobantes SIRE: import por modal (+) y conciliación en la DB (botón → SP).
function SireList(props) {
  const { entity, title, permission } = props;
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [records, setRecords] = useState([]);
  const [filter, setFilter] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [conciliando, setConciliando] = useState(false);

  async function listRecords() {
    setDataLoading(true);
    const res = await wsFindBy(entity, filter);
    setDataLoading(false);
    if (res.success) setRecords(res.data);
  }

  async function conciliar() {
    setConciliando(true);
    const res = await wsPost(`${entity}/conciliar`, {
      start_date: filter.start_date,
      end_date: filter.end_date,
    });
    setConciliando(false);
    if (res.success) {
      showNotify(res.message || 'Conciliación realizada', 'success');
      listRecords();
    } else {
      showNotify(res.message || 'Error al conciliar', 'error');
    }
  }

  useEffect(() => {
    if (Object.keys(filter).length === 0) return;
    listRecords();
  }, [filter]);

  return (
    <CardContainer
      title={(<>{title} {dataLoading && <LoadingSpinner />}</>)}
      color="success"
      permission={permission}
      icon={<Add />}
      onClick={() => setOpen(true)}
    >
      <Toasty action={notify} />
      <SireModal
        open={open}
        onClose={() => setOpen(false)}
        entity={entity}
        title={`Importar ${title}`}
        showNotify={showNotify}
        reload={listRecords}
      />
      <FilterCustom dateRange diffRange={7} getFilter={setFilter} />
      <RegularButton color="primary" disabled={conciliando || records.length === 0} onClick={conciliar}>
        {conciliando ? 'Conciliando...' : 'Conciliar con SAP'}
      </RegularButton>
      <ReactTable
        defaultWidth={1700}
        columns={columns}
        formatDate="DD-MM-YYYY"
        data={records.map((item, i) => ({
          ...item,
          num: (
            <div className="actions-right">
              {i + 1}
              <AllowedGuard permission={ConstantPermissions.SALE_ORDERS_DELETED}>
                <ButtonDelete entity={entity} id={item.id} reload={() => listRecords()} />
              </AllowedGuard>
            </div>
          ),
          existsBadge:
            item.exists_sap == null ? (
              <Badge color="warning">Pendiente</Badge>
            ) : (
              <Badge color={item.exists_sap === 'Y' ? 'success' : 'danger'}>
                {item.exists_sap === 'Y' ? 'Sí' : 'No'}
              </Badge>
            ),
          tipo: TIPO_LABEL[item.document_type] || item.document_type,
          ruc: item.partner ? item.partner.LicTradNum : '-',
          partner_name: item.partner ? item.partner.CardName : '-',
          card_code: item.partner ? item.partner.CardCode : '-',
          total: nDecimal(item.total),
        }))}
      />
    </CardContainer>
  );
}

export default WithApp(SireList);
